// Local library
import { SessionService } from '@amwager/data-access';

// Angular
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'feature-ion-pay-near-me',
  templateUrl: './pay-near-me.component.html',
  styleUrls: ['./pay-near-me.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PayNearMeComponent implements OnInit {

  private PAYNEARME_URL = 'pro.paynearme-sandbox.com';
  private PAYNEARME_SITEID = 'S5373564450';

  constructor(
    private readonly sessionService: SessionService,
  ) { }

  ngOnInit() {
    // update branch 2
    null;
  }

  openLink(): void {

    const date = new Date(this.sessionService.getUserDOB());

    const payNearMeLink = 'https://' + this.PAYNEARME_URL +
    '/api/buy_now?site_customer_identifier=' + this.sessionService.getSubscription() +
    '&site_identifier=' + this.PAYNEARME_SITEID +
    '&order_currency=USD&order_type=any&site_customer_email=' + this.sessionService.getUserEmail() +
    '&order_is_standing=true' +
    '&site_customer_first_name=' + this.sessionService.getUserFName() +
    '&site_customer_last_name=' + this.sessionService.getUserLast() +
    '&site_customer_year_of_birth=' + date.getFullYear();

    window.open(payNearMeLink,'PayNearMe for Wagering', 'width=800, height=600');
  }

}
